interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "center" | "left";
}

/**
 * Header di sezione condiviso con accento terracotta.
 * Centrato per default, eyebrow distinto dal titolo (no ridondanza).
 */
const SectionHeader = ({ eyebrow, title, description, align = "center" }: SectionHeaderProps) => {
  const alignment = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <div className={`mb-4 md:mb-6 max-w-3xl flex flex-col ${alignment}`}>
      {eyebrow && (
        <div className="flex items-center gap-2 mb-1.5">
          <span className="h-px w-6 bg-terracotta" aria-hidden="true" />
          <span className="text-[10px] sm:text-xs uppercase tracking-[0.22em] text-terracotta font-medium">
            {eyebrow}
          </span>
          <span className="h-px w-6 bg-terracotta" aria-hidden="true" />
        </div>
      )}
      <h2 className="font-display text-2xl md:text-3xl lg:text-4xl text-foreground leading-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed max-w-2xl">
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
